import { Route, Switch } from 'react-router';
import { AccountSettings } from '../views/Settings/Account';
import { NotificationsSettings } from '../views/Settings/Notifications';

import { PaymentsSettings } from '../views/Settings/Payments';
import { Settings } from '../views/Settings/Settings';

import { VirtualOffice } from '../views/Settings/VirtualOffice';
import {
  SETTINGS_ACCOUNT,
  SETTINGS_NOTIFICATIONS,
  SETTINGS_PAYMENTS,
  SETTINGS_VIRTUAL_OFFICE
} from './routes';

export const SettingsRoutes = () => (
  <Settings>
    <Switch>
      <Route
        exact
        path={`${SETTINGS_ACCOUNT}`}
        render={() => <AccountSettings />}
      />

      <Route
        exact
        path={`${SETTINGS_PAYMENTS}`}
        render={() => <PaymentsSettings />}
      />

      <Route
        exact
        path={`${SETTINGS_VIRTUAL_OFFICE}`}
        render={() => <VirtualOffice />}
      />

      <Route
        exact
        path={`${SETTINGS_NOTIFICATIONS}`}
        render={() => <NotificationsSettings />}
      />
    </Switch>
  </Settings>
);
